import { ActionButton } from "@fluentui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { routes } from "../../../config/routes";

type Props = {
  isActive?: boolean;
};

const TradeLicensePlatesBtn = ({ isActive }: Props) => {
  const { fleetId } = useParams() as any;
  const { t } = useTranslation();

  return (
    <Link to={routes.tradeLicensePlates.getPath(fleetId)}>
      <ActionButton
        styles={{
          root: {
            fontWeight: isActive ? "bold" : "inherit",
          },
        }}
        iconProps={{
          iconName: "Market",
          styles: {
            root: {
              fontWeight: isActive ? "bold" : "inherit",
            },
          },
        }}
        text={t("bfm.tradeLicensePlates.label")}
      />
    </Link>
  );
};

export default TradeLicensePlatesBtn;
